import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import token from './token'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import utils from './utils'


import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
VMdPreview.use(githubTheme)
Vue.use(VMdPreview);

//引入quill-editor编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

//实现quill-editor编辑器拖拽上传图片
import * as Quill from 'quill'
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
import Calendar from 'vue2-datepick'; //日期控件

Vue.use(Calendar);//日期控件

//实现quill-editor编辑器调整图片尺寸
// import  ImageResize from 'quill-image-resize-module'
// Quill.register('modules/imageResize', ImageResize)

import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
VueMarkdownEditor.use(vuepressTheme);
Vue.use(VueMarkdownEditor);
Vue.use(ElementUI)
Vue.use(token);
Vue.config.productionTip = false
Vue.prototype.utils = utils

Vue.directive('title',{
  update(dom){
    document.title = dom.dataset.title
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
